module.exports = __webpack_public_path__ + "static/science-cover-6007d3caee3a12267ab6a34a5fd6ea13.svg";